//屏幕适应
(function (doc, win) {
    var docEl = doc.documentElement,
        resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
        recalc = function (e) {
            var clientWidth = docEl.clientWidth;
            var clientHeight = docEl.clientHeight;
            if (!clientWidth) return;
            if (clientWidth <= 1080) {
                let orientation = e.orientation != undefined ? e.orientation : window.orientation;
                if (orientation == 90 || orientation == -90) {
                    // 横屏
                    docEl.style.fontSize = 100 * (clientHeight / 750) + 'px';
                } else {
                    // 竖屏
                    docEl.style.fontSize = 100 * (clientWidth / 750) + 'px';
                }
            } else {
                docEl.style.fontSize = '100px';
            }
        };

    if (!doc.addEventListener) return;
    win.addEventListener(resizeEvt, recalc, false);
    doc.addEventListener('DOMContentLoaded', recalc, false);
    win.addEventListener('orientationchange', recalc, false);
})(document, window);

